// Passion Program-ийн хөдөлгөөнт дүрс (inline SVG + CSS keyframes, index.css "pi-*"). Хөдөлгөөн багасгах тохиргоонд зогсоно.
// icon: basketball, volleyball, bjj, fitness, drama, calligraphy, tabletennis, pickleball, chess, dance, football; бусад → star
import React from "react";

const TONE = {
  basketball: ["#fff1e6", "#ea580c"], volleyball: ["#e0f2fe", "#0369a1"], bjj: ["#f3eeff", "#5c1090"], fitness: ["#dcfce7", "#15803d"],
  drama: ["#fef3c7", "#b45309"], calligraphy: ["#f1f5f9", "#1f2937"], tabletennis: ["#fee2e2", "#b91c1c"], pickleball: ["#ecfccb", "#4d7c0f"],
  chess: ["#f3f4f6", "#111827"], dance: ["#fce7f3", "#be185d"], football: ["#dcfce7", "#166534"], star: ["#f3eeff", "#5c1090"],
};

function Art({ k, c }) {
  const s = { fill: "none", stroke: c, strokeWidth: 2.4, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (k) {
    case "basketball":
      return (<>
        <ellipse className="pi-shadow" cx="24" cy="42" rx="8" ry="1.8" fill={c} opacity=".18" />
        <g className="pi-bounce"><circle cx="24" cy="18" r="10" {...s} /><path d="M14 18h20M24 8v20M17 11c4 4 4 10 0 14M31 11c-4 4-4 10 0 14" {...s} strokeWidth="1.8" /></g>
      </>);
    case "volleyball":
      return (<g className="pi-spin-bounce"><circle cx="24" cy="24" r="11" {...s} /><path d="M24 13c-2 6 0 12 7 15M13.5 21c6-1 11 2 13 8M20 34c2-6 7-10 14-9" {...s} strokeWidth="1.8" /></g>);
    case "bjj":
      return (<>
        <g className="pi-kick-body"><circle cx="18" cy="11" r="3.5" {...s} /><path d="M18 15v12M18 19l-6 5M18 19l7-3" {...s} /><path d="M18 27l-5 11" {...s} /></g>
        <g className="pi-kick-leg" style={{ transformOrigin: "18px 27px" }}><path d="M18 27l12 4" {...s} /></g>
        <path d="M13 22h10" stroke={c} strokeWidth="3" strokeLinecap="round" opacity=".35" />
      </>);
    case "fitness":
      return (<g className="pi-lift"><path d="M10 24h28" {...s} /><rect x="7" y="18" width="4" height="12" rx="1.5" {...s} /><rect x="37" y="18" width="4" height="12" rx="1.5" {...s} /><rect x="12" y="20" width="3" height="8" rx="1" {...s} /><rect x="33" y="20" width="3" height="8" rx="1" {...s} /></g>);
    case "drama":
      return (<>
        <g className="pi-tilt-l" style={{ transformOrigin: "17px 22px" }}><path d="M8 12c6-3 12-3 18 0v9c0 6-4 10-9 10s-9-4-9-10z" {...s} /><path d="M12 19h3M20 19h3M13 25c2 2 6 2 8 0" {...s} strokeWidth="1.8" /></g>
        <g className="pi-tilt-r" style={{ transformOrigin: "31px 26px" }}><path d="M22 18c6-3 12-3 18 0v9c0 6-4 10-9 10s-9-4-9-10z" {...s} /><path d="M26 25h3M34 25h3M27 32c2-2 6-2 8 0" {...s} strokeWidth="1.8" /></g>
      </>);
    case "calligraphy":
      return (<>
        <path className="pi-draw" d="M8 34c6-10 10 4 16-6s8 6 14-4" {...s} strokeWidth="3" />
        <g className="pi-brush"><path d="M34 6l6 6-10 10-6-6z" {...s} /><path d="M24 16l-3 7 7-3" {...s} /></g>
      </>);
    case "tabletennis":
    case "pickleball":
      return (<>
        <g className="pi-swing" style={{ transformOrigin: "16px 34px" }}><circle cx="20" cy="22" r="8" {...s} /><path d="M16 29l-5 8" {...s} strokeWidth="3.4" /></g>
        <circle className="pi-ball" cx="34" cy="16" r="2.8" fill={c} />
      </>);
    case "chess":
      return (<g className="pi-hop"><path d="M17 38h16M19 34h12l-2-8c4-2 5-7 3-11-2-3-7-5-11-3l-3 4 2 2-4 4 3 2 4-3" {...s} /><circle cx="24" cy="17" r="1" fill={c} /></g>);
    case "dance":
      return (<g className="pi-sway" style={{ transformOrigin: "24px 40px" }}><circle cx="24" cy="9" r="3.5" {...s} /><path d="M24 13v13M24 17l-8-4M24 17l8 2M24 26l-6 12M24 26l7 11" {...s} /></g>);
    case "football":
      return (<>
        <ellipse cx="24" cy="42" rx="10" ry="1.8" fill={c} opacity=".18" />
        <g className="pi-roll" style={{ transformOrigin: "24px 28px" }}><circle cx="24" cy="28" r="10" {...s} /><path d="M24 22l5 4-2 6h-6l-2-6z" {...s} strokeWidth="1.8" /></g>
      </>);
    default:
      return (<path className="pi-pulse" style={{ transformOrigin: "24px 24px" }} d="M24 8l4.7 9.6 10.6 1.5-7.7 7.5 1.8 10.5L24 32l-9.4 5.1 1.8-10.5-7.7-7.5 10.6-1.5z" {...s} />);
  }
}

export default function PassionIcon({ icon, size = 56, still = false }) {
  const k = TONE[icon] ? icon : "star";
  const [bg, fg] = TONE[k];
  return (
    <span className={`inline-flex items-center justify-center rounded-2xl shrink-0 ${still ? "" : "pi-live"}`} style={{ width: size, height: size, background: bg }} aria-hidden="true">
      <svg viewBox="0 0 48 48" width={size * 0.78} height={size * 0.78} style={{ overflow: "visible" }}><Art k={k} c={fg} /></svg>
    </span>
  );
}
